export enum LlmRegion {
  EU = "EU",
  UAE = "UAE",
}
